// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3aQQf","toggleWrap":"styles_toggleWrap__3uvVm","content":"styles_content__10YEj","selectAreaCode":"styles_selectAreaCode__2233d"};